<template>
  <div class="custom-select">
    <!-- Selected Image -->
    <div class="selected-item" @click="toggleDropdown">
      <img
        v-if="selectedImage !== null"
        :src="`/assets/avatar/contacts/${selectedImage.toString().padStart(3, '0')}.png`"
        :alt="`Avatar ${selectedImage}`"
        class="selected-image"
      />
      <span>{{$t('select_avatar')}}</span>
    </div>
    <span
      v-for="err in errors"
      :key="err.$uid"
      class="text-red-alert block mt-[5px] text-[13px]"
    >
      {{ err.$message }}
    </span>
    <!-- Dropdown Options -->
    <div v-if="isOpen" class="dropdown">
      <div
        v-for="n in 24"
        :key="n"
        class="dropdown-item"
        @click="selectImage(n)"
      >
        <img
          :src="`/assets/avatar/contacts/${n.toString().padStart(3, '0')}.png`"
          :alt="`Avatar ${n}`"
          class="dropdown-image"
        />

      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, defineProps, defineEmits } from 'vue';

// Props
defineProps({
  modelValue: {
    type: Number,
    default: null, // Default value for the selected image
  },
  errors: {
    type: Array,
    default: () => [],
  },
});

// Emit
const emit = defineEmits(['update:modelValue']);

// Reactive variables
const selectedImage = ref(null); // Store the selected image index
const isOpen = ref(false);       // Control the dropdown visibility

// Methods
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectImage = (imageNumber) => {
  selectedImage.value = imageNumber;
  isOpen.value = false; // Close the dropdown after selection
  emit('update:modelValue', imageNumber); // Emit the selected image
};
</script>

<style scoped>
.custom-select {
  position: relative;

}

.selected-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
}

.selected-item img {
  height: 40px;
  width: 40px;
  margin-right: 10px;
  border-radius: 5px;
}

.dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 150px;
  border: 1px solid #ccc;
  background-color: white;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  border-radius: 5px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item img {
  width: 100%;
  margin-right: 10px;
  border-radius: 5px;
}
</style>
